import React, { Component } from 'react';
import Header from './header';
import * as firebase from "firebase/app";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Row
} from "reactstrap";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  googleLogin() {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider).then((result) => {
      // This gives you a Google Access Token. You can use it to access the Google API.
      //var token = result.credential.accessToken;
      // The signed-in user info.
      this.props.history.push('/home');
      // ...
    }).catch(function (error) {
      // Handle Errors here.
      // var errorCode = error.code;
      //var errorMessage = error.message;
      // The email of the user's account used.
      //  var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      // var credential = error.credential;
      // ...
    });
  }


  render() {
    return (
      <div>
        <Header />
        <div className="app flex-row align-items-center">
          <Container style={{marginTop:"60px"}}>
            
            <Row className="justify-content-center">
              <Col md="9" >
                
                  <Card className="p-4" style={{backgroundImage:
                  'url(' + 'http://www.karvywealth.com/Data/Sites/1/media/images/wealth-management-products-1.jpg' + ')',
                  height: "252px",backgroundRepeat: 'no-repeat',backgroundSize: 'cover'}}  >
                    <CardBody style={{position:'relative'}}>
                      <Form onSubmit={this.handleSubmit}>
                        <h1>SellAndBuy</h1>
                        <Row style={{left: "8%",position: 'absolute',top: '67%'}}>
                          <Col xs="12">
                            <Button

                              type="submit"
                              style={{backgroundColor: "#C93921"}}
                              className="px-4"
                              onClick={(event) => {
                                event.preventDefault();
                                this.googleLogin()
                              }}
                            >
                              Login with Google
                            </Button>
                          </Col>

                        </Row>
                      </Form>
                    </CardBody>
                  </Card>
              </Col>
            </Row>
          </Container>
        </div>

      </div>
    );
  }
}

export default Login;